import React, { useState, useEffect } from "react";
import { createUserWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import "../AuthFormStyles.css";
import Header from './Header'; // Make sure this path is correct
import { useNightMode } from '../NightModeContext'; // Make sure this path is correct
import { useTasks } from 'components/Schedule/TaskContext';

const SignUp = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(''); // State to store the error message
    const navigate = useNavigate();
    const { isNightMode, toggleNightMode } = useNightMode();
    const { setUser } = useTasks();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);
                navigate("/home");
            }
        });
        return unsubscribe;
    }, [navigate, setUser]);

    const onSignUp = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError("Please enter both email and password."); // Set an error if fields are empty
            return;
        }
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                setUser(userCredential.user);
                navigate("/home");
            }).catch((error) => {
                setError(error.message); // Set the error from Firebase authentication
            });
    };

    return (
        <>
            <Header isNightMode={isNightMode} toggleNightMode={toggleNightMode} />
            <div className="card">
                <form onSubmit={onSignUp}>
                    <h1>Sign Up</h1>
                    {error && <p className="error-message">{error}</p>} {/* Display error message */}
                    <input type="email" placeholder="Email" className="auth-input" value={email} onChange={(e) => setEmail(e.target.value)} />
                    <input type="password" placeholder="Password" className="auth-input" value={password} onChange={(e) => setPassword(e.target.value)} />
                    <div className="button-container">
                        <button type="submit" className="auth-button">Sign Up</button>
                        <button type="button" onClick={() => navigate("/signin")} className="switch-button">Log In</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default SignUp;
